import { useSlots as p, reactive as H, computed as n, ref as o, onUpdated as M } from "vue";
function y(h) {
  const e = p(), r = H(h), g = n(() => r.error), l = o(!!(e != null && e.error)), s = n(() => !!(l.value || g.value)), B = n(() => s.value || r.isInvalid), w = n(() => r.warning), u = o(!!(e != null && e.warning)), f = n(
    () => !!(u.value || w.value)
  ), E = n(() => r.success), m = n(() => !!E.value), d = n(() => r.help), c = o(!!(e != null && e.help)), S = n(() => !!(c.value || d.value));
  return M(() => {
    const a = p(), t = o(!!(a != null && a.error)), v = o(!!(a != null && a.warning)), i = o(!!(a != null && a.help));
    t.value !== l.value && (l.value = t.value), v.value !== u.value && (u.value = v.value), i.value !== c.value && (c.value = i.value);
  }), { hasError: s, showErrorClass: B, hasWarning: f, hasSuccess: m, hasHelp: S };
}
export {
  y as useNotificationHandler
};
